module.exports = __webpack_public_path__ + "img/globe.dafece68.svg";